// extracted by mini-css-extract-plugin
export default {"button":"style_button__HRfp0","button-primary":"style_button-primary__ke7Mx","button-secondary":"style_button-secondary__CmbHr"};